export const RISK_TIERS = ["Low", "Medium", "High", "Critical"];
export const LIFECYCLE_STATUSES = [
    "Under Review",
    "Mission Ready",
    "Restricted",
    "Suspended",
    "Retired",
];
export const PRODUCT_TYPES = ["In-House", "Bundled", "Third-Party"];
export const MODE_NAMES = ["Fast Track", "Standard", "Critical Systems Track"];
export const ROLES = ["Systems Lead", "Product Owner", "Security", "Supply", "Executive"];

export function RiskBadge({ tier }) {
    const map = {
        Low: "border-green-500/50 text-green-400 bg-green-500/5",
        Medium: "border-yellow-500/50 text-yellow-400 bg-yellow-500/5",
        High: "border-signal/60 text-signal bg-signal/5",
        Critical: "border-red-500/60 text-red-400 bg-red-500/5",
    };
    return (
        <span
            data-testid={`risk-badge-${tier.toLowerCase()}`}
            className={`inline-flex items-center border px-2 py-0.5 text-[11px] uppercase tracking-[0.2em] font-mono ${map[tier]}`}
        >
            {tier}
        </span>
    );
}

export function LifecycleBadge({ status }) {
    const map = {
        "Under Review": "border-snow-dim/40 text-snow-dim",
        "Mission Ready": "border-signal text-signal bg-signal/5",
        Restricted: "border-yellow-500/50 text-yellow-400",
        Suspended: "border-red-500/40 text-red-400",
        Retired: "border-snow-muted/30 text-snow-muted line-through",
    };
    const label = status === "Mission Ready" ? "ACTIVE • MISSION READY" : status;
    return (
        <span
            data-testid={`lifecycle-badge-${status.replace(/\s+/g, "-").toLowerCase()}`}
            className={`inline-flex items-center border px-2 py-0.5 text-[11px] uppercase tracking-[0.2em] font-mono ${map[status]}`}
        >
            {label}
        </span>
    );
}

export function KillSwitchBadge({ active, size = "md" }) {
    if (!active) {
        return (
            <span className="inline-flex items-center border border-hairline text-snow-muted px-2 py-0.5 text-[11px] uppercase tracking-[0.2em] font-mono">
                Armed
            </span>
        );
    }
    const cls =
        size === "lg"
            ? "px-3 py-1 text-sm"
            : "px-2 py-0.5 text-[11px]";
    return (
        <span
            data-testid="kill-switch-alert-badge"
            className={`inline-flex items-center bg-signal text-jet font-bold uppercase tracking-[0.25em] ${cls} animate-pulse-signal`}
        >
            ▲ ALERT
        </span>
    );
}

export function ReadinessBar({ value }) {
    const v = Math.max(0, Math.min(100, value || 0));
    const color = v >= 80 ? "#FF6A00" : v >= 50 ? "#FFC107" : "#FF3B30";
    return (
        <div className="flex items-center gap-2 min-w-[140px]">
            <div className="font-mono tabular-nums text-xs w-8 text-right">{v}</div>
            <div className="flex-1 h-1.5 bg-jet-elev2 border border-hairline">
                <div className="h-full" style={{ width: `${v}%`, backgroundColor: color }} />
            </div>
        </div>
    );
}
